exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.sc-delivery-options-column[data-v-61b30096] {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-delivery-options/ScDeliveryOptions.vue"],"names":[],"mappings":";AACA;EACE,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;CAC7B","file":"ScDeliveryOptions.vue","sourcesContent":["\n.sc-delivery-options-column[data-v-61b30096] {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61b30096","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-delivery-options/ScDeliveryOptions.vue
// module id = DBF7
// module chunks = 72